<template>
	<ViewFeedItem class="view-feed-usernew">
		<template v-slot:header>
			<ViewLayoutModuleHeader title="Fresh faces to follow">
				<RouterLink v-bind:to="{ name: 'PageUsers' }">
					<strong>View All</strong>
				</RouterLink>
			</ViewLayoutModuleHeader>
		</template>

		<template v-slot:body>
			<ChalkyUserList
				class="horizontal"
				v-bind:useLocation="true"
				v-bind:userCollection="userCollection"
				v-on:click="Handle_OnSelectUser"
			/>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, bind, event, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedUserNew extends ViewBase {
		/**
		 * @type ChalkySticks/Collection/User
		 */
		@Prop({
			default: () => ChalkySticks.Factory.User.collection({ limit: 8 }),
		})
		public userCollection!: ChalkySticks.Collection.User;

		/**
		 * @return void
		 */
		@mounted
		public setup(): void {
			this.userCollection.fetch();
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param PointerEvent e
		 * @param ChalkySticks.Model.User userModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectUser(e: PointerEvent, userModel: ChalkySticks.Model.User): Promise<void> {
			this.$store.dispatch('gotoUser', userModel);
		}

		// endregion: Event Handlers
	}
</script>
